import React, { Component } from 'react';
import autoBind from "react-autobind";

import updateState from '../../common/updateState';
import { QuestionnaireCompleted } from './QuestionnaireCompleted';

const TIMEOUT = 5000;

export class QuestionnaireCompletedContainer extends Component {
  constructor(props) {
    super(props)
    autoBind(this);

    const { redirectUrl } = props.location.state
    this.state = {
      redirectUrl: redirectUrl,
      countDown: TIMEOUT
    }
    this.startRedirectTimer();
  }

  render() {
    const { redirectUrl, countDown } = this.state
    return (
      <div>
        <QuestionnaireCompleted 
          countDown={countDown} 
          redirectUrl={redirectUrl} />
      </div>
    )
  }

  startRedirectTimer() {
    const interval = setInterval(function() {
      const nextCountDownNumber = this.state.countDown - 1000;
      if (nextCountDownNumber !== 0) {
        updateState(this, {
          countDown: nextCountDownNumber
        });
      } else {
        clearInterval(interval);
        window.location.href = this.state.redirectUrl;
      }
    }.bind(this), 1000);
  }
}




// WEBPACK FOOTER //
// ./src/components/questionnaireCompleted/QuestionnaireCompletedContainer.js